import { useStore } from '../../../../hooks/useStore';
import { usePxtraCardEnabled } from '../../../../hooks/usePxtraCardEnabled';

/** Whether this company can put the pxtra Card on a benefit set at all. The
 * panel additionally needs Sachbezug selected in the set. Callers must be
 * observers. */
export const useCardOfferApplies = () => {
  const { isCardEnabled } = usePxtraCardEnabled();
  const { companyStore } = useStore();

  return isCardEnabled && companyStore.bookedBenefits.includes('sachbezug');
};
